import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { WaiverSteps } from 'src/app/alv-enums';
import { WaiverService } from 'src/app/services/waiver.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
	selector: 'password-info',
	templateUrl: './password-info.component.html',
	styleUrls: ['./password-info.component.scss']
})
export class PasswordInfoComponent implements OnInit {
	passwordInfo: string;
	message: string;

	constructor(public storeService: StoreService,
		public waiverService: WaiverService,
		public toolsService:ToolsService) { }

	ngOnInit() {
	}
	
	goToStep(step: WaiverSteps) {
		const self = this;
		//go to next step guest selection
		self.waiverService.onStepChangeForward(step);
	}
	onSubmit() {
		const self = this;
		this.message = "";
		this.waiverService.loginWaiverUser(this.storeService.waiver.email, this.passwordInfo)
			.then(response => {
				//if valid login
				if (response.succeeded == true) {
					this.goToStep(WaiverSteps.guestSelection)
				}
				else {
					this.message = response.message;
				}
			});
			window.scroll(0,0)
	}
	resetPassword()
	{
		this.waiverService.resetPassword(this.storeService.waiver.email,this.storeService.waiver.signee.guestAccountId).then(response => {
			//if valid login
			if (response.succeeded == true) {
				this.toolsService.showSuccess('A new Password is emailed');
			}
			else {
				this.toolsService.showError('An unexpcted error occured in restting password');
			}
		});
	}
}
